import React, { useState, useEffect } from 'react';
import { API } from '../../utils/api';

const FilterPresetsTab = ({ token, showToast, loadPreferences }) => {
  const [presets, setPresets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [importCode, setImportCode] = useState('');

  useEffect(() => {
    const x = new XMLHttpRequest();
    x.open('GET', `${API}/filter-shares/public`, true);
    x.onload = function () {
      setLoading(false);
      if (x.status < 300) {
        try { setPresets(JSON.parse(x.responseText).shares || []); } catch (e) {}
      }
    };
    x.onerror = () => setLoading(false);
    x.send();
  }, []);

  const importPreset = (code) => {
    const x = new XMLHttpRequest();
    x.open('POST', `${API}/filter-share/${code}/import`, true);
    if (token) x.setRequestHeader('Authorization', `Bearer ${token}`);
    x.onload = function () {
      if (x.status < 300) {
        try {
          const res = JSON.parse(x.responseText);
          loadPreferences(res.filters);
          showToast(`Imported "${res.name}" from ${res.from_user}!`, 'success');
        } catch (e) {}
      } else {
        showToast('Share code not found', 'error');
      }
    };
    x.send();
  };

  return (
    <div data-testid="filter-presets-tab">
      <div className="ocean-shimmer" style={{ background: '#475569', borderRadius: 12, padding: 16, border: '1px solid rgba(253, 230, 138,0.15)', position: 'relative', marginBottom: 16 }}>
        <div style={{ position: 'relative', zIndex: 4 }}>
          <h3 className="shimmer-text" style={{ margin: '0 0 8px', fontSize: '1.05rem' }}>
            <i className="fas fa-share-alt" style={{ marginRight: 8, color: '#38bdf8' }} />
            Shared Filter Presets
          </h3>
          <p style={{ color: '#71717a', fontSize: '0.76rem', marginBottom: 10 }}>
            Browse presets shared by the community or import by code. Share your own from Settings.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="text" value={importCode} onChange={e => setImportCode(e.target.value)}
              placeholder="Enter share code to import..." data-testid="marketplace-filter-import"
              style={{ flex: 1, background: 'rgba(253, 230, 138,0.06)', border: '1px solid rgba(253, 230, 138,0.2)', color: '#334155', padding: '8px 12px', borderRadius: 8, fontSize: '0.8rem' }}
              onKeyDown={e => { if (e.key === 'Enter' && importCode.trim()) { importPreset(importCode.trim()); setImportCode(''); } }} />
            <button onClick={() => { if (importCode.trim()) { importPreset(importCode.trim()); setImportCode(''); } }}
              className="btn-ocean" style={{ background: 'rgba(253, 230, 138,0.12)', border: '1px solid rgba(253, 230, 138,0.3)', color: '#38bdf8', padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600 }}>
              Import
            </button>
          </div>
        </div>
      </div>

      {loading && <div style={{ color: '#71717a', textAlign: 'center', padding: 30 }}>Loading shared presets...</div>}
      {!loading && presets.length === 0 && (
        <div style={{ color: '#555', textAlign: 'center', padding: 30, fontSize: '0.82rem' }}>
          <i className="fas fa-lightbulb" style={{ color: '#f59e0b', marginRight: 6 }} />
          No shared presets yet. Be the first — share your filter setup from Settings!
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 12 }}>
        {presets.map(p => (
          <div key={p.share_code} className="ocean-shimmer shimmer-border" style={{
            background: '#475569', borderRadius: 12, padding: 14, position: 'relative',
            border: '1px solid rgba(252, 211, 77,0.15)', overflow: 'hidden'
          }} data-testid={`preset-${p.share_code}`}>
            <div style={{ position: 'relative', zIndex: 4 }}>
              <h4 style={{ margin: '0 0 4px', color: '#334155', fontSize: '0.9rem' }}>{p.name}</h4>
              <div style={{ display: 'flex', gap: 8, fontSize: '0.68rem', color: '#71717a', marginBottom: 6, flexWrap: 'wrap' }}>
                <span>by {p.username || 'Anonymous'}</span>
                <span>{p.views || 0} views</span>
                <span>{p.imports || 0} imports</span>
              </div>
              {p.description && <p style={{ color: '#a1a1aa', fontSize: '0.72rem', margin: '0 0 8px' }}>{p.description}</p>}
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => importPreset(p.share_code)} className="btn-ocean"
                  style={{ flex: 1, background: 'rgba(253, 230, 138,0.12)', border: '1px solid rgba(253, 230, 138,0.3)', color: '#38bdf8', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem', fontWeight: 600 }}>
                  <i className="fas fa-download" style={{ marginRight: 4 }} /> Import
                </button>
                <button onClick={() => { navigator.clipboard.writeText(p.share_code); showToast('Share code copied!', 'success'); }}
                  className="btn-ocean" style={{ background: 'rgba(252, 211, 77,0.12)', border: '1px solid rgba(252, 211, 77,0.3)', color: '#047857', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem' }}>
                  <i className="fas fa-copy" style={{ marginRight: 4 }} /> Code
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterPresetsTab;
